export function tabs() {
    $(".tabs-holder").each(function () {
        const $tabsHolder = $(this);
        const $firstTabNav = $tabsHolder.find(".tabs-nav > li:first-child");
        const $firstTab = $tabsHolder.find(".tabs > .tab:first-child");

        if ($tabsHolder.find(".tabs-nav > li.active").length === 0) {
            $firstTabNav.addClass("active");
        }

        if ($tabsHolder.find(".tabs > .tab.active").length === 0) {
            $firstTab.addClass("active");
        }
    });

    $(".tabs-nav").on("click", "a", function (e) {
        e.preventDefault();

        let tab = $(this).parent();
        let tabIndex = tab.index();
        let nav = tab.parent(".tabs-nav");
        let tabsHolder = nav.siblings(".tabs");
        let $tabsHolder = nav.closest(".tabs-holder");

        nav.find("> li").removeClass("active");
        tab.addClass("active");
        tabsHolder.find("> .tab").removeClass("active");
        tabsHolder.find("> .tab").eq(tabIndex).addClass("active");
        if (tabsHolder.find("> .tab .featured-products-slider").length > 0) {
            tabsHolder.find("> .tab .featured-products-slider").slick('setPosition');
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/tabs.js